import { string } from "prop-types"
import React from "react"
import Flex from "../Flex"
import Box from "../Box"
import Text from "../Text"

function ColorCard({ name, hex, rgb, ...props }) {
  return (
    <Flex
      id={name}
      width={1}
      height={206}
      px={3}
      py={3}
      bg="white"
      borderRadius={1}
      flexDirection="column"
      {...props}
    >
      <Box
        bg={hex}
        width={1}
        height={104}
        borderRadius={1}
        boxShadow={3}
        mb={3}
      />

      <Text color="Ink" fontWeight={600}>
        {name}
      </Text>

      <Text color="Ink Lighter" fontSize={0} mt={1}>
        {hex}
      </Text>
    </Flex>
  )
}

ColorCard.propTypes = {
  name: string.isRequired,
}

export default ColorCard



// WEBPACK FOOTER //
// ./src/components/colorfinder/ColorCard.js